import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function HotSection() {
  const hotComics = comics.filter((c) => c.isHot).slice(0, 6);

  return (
    <section className="py-10 md:py-14">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-100">
              热门推荐
            </h3>
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-fire-line text-accent-500"></i>
            </div>
          </div>
          <Link
            to="/category/all?sort=hot"
            className="flex items-center gap-1 text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
          >
            更多热门
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
          {hotComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}